import styled from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  margin-top: auto;
  padding-bottom: 10px;
  @media (max-width: 750px) {
    margin-top: auto;
  }
`;

export const Base64Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MediaInputRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;

  > :first-child {
    flex: 1;
  }

  @media (max-width: 750px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const MediaPreviewGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
`;

export const MediaPreviewWrapper = styled.div`
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.neutral800};
  background-color: ${({ theme }) => theme.neutral900};
  min-height: 120px;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  position: relative;

  img,
  video {
    width: 100%;
    height: 180px;
    object-fit: cover;
    display: block;
  }
`;

export const MediaPreviewRemoveButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  border: none;
  background-color: rgba(0, 0, 0, 0.7);
  color: ${({ theme }) => theme.neutral0};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 200ms ease;

  &:hover {
    filter: brightness(1.15);
  }
`;

export const OptionsTagList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${SPACING._4};
  > li {
    width: min-content;
    cursor: pointer;
    white-space: nowrap;
  }
`;
